import { PageNumber } from './Pagination.types'
import { DOTS } from './Pagination.consts'

function getRange(from: number, to: number): number[] {
  if (from < 0 || to < 0 || from > to) {
    return []
  }
  const length = to - from + 1

  return Array.from(Array(length), (_, index) => index + from)
}

// eslint-disable-next-line import/prefer-default-export
export function getPaginationRange(page: number, total: number, siblingsCount: number, boundariesCount: number): PageNumber[] {
  const siblings = Math.max(siblingsCount, 0)
  const boundaries = Math.max(boundariesCount, 0)
  // Desired items count: left/right boundaries + left/right siblings + 2*DOTS + current
  const totalItemsCount = boundaries * 2 + siblings * 2 + 3

  if (totalItemsCount >= total) {
    return getRange(1, total)
  }

  const leftSiblingIndex = Math.max(page - siblings, boundaries)
  const rightSiblingIndex = Math.min(page + siblings, total - boundaries)

  // Don't show dots if there is only 1 position left after/before page count
  const showLeftDots = leftSiblingIndex > boundaries + 2
  const showRightDots = rightSiblingIndex < total - (boundaries + 1)

  if (!showLeftDots && showRightDots) {
    const leftItemCount = siblings * 2 + boundaries + 2

    return [...getRange(1, leftItemCount), DOTS, ...getRange(total - (boundaries - 1), total)]
  }

  if (showLeftDots && !showRightDots) {
    const rightItemCount = boundaries + 1 + 2 * siblings

    return [...getRange(1, boundaries), DOTS, ...getRange(total - rightItemCount, total)]
  }

  return [...getRange(1, boundaries), DOTS, ...getRange(leftSiblingIndex, rightSiblingIndex), DOTS, ...getRange(total - boundaries + 1, total)]
}
